import { ReactElement } from 'react';
import { Button } from '@components/form/button';
import { getStyle } from '@utils/style';
import { DynamicTypography } from '@components/DynamicTypography';
import { FormValue, Question } from '@app/types';

interface Type2Props {
  group: {
    key: string;
  };
  g: {
    options: Question[];
  };
  values: Record<string, FormValue>;
  setFieldValue: (key: string, value: number) => void;
}

export const Type2 = ({ group, g, values, setFieldValue }: Type2Props): ReactElement => {
  const isTrue = (k: number): boolean => {
    return values[group.key] === k;
  };

  return (
    <section className="type-2-questionnaire">
      <div className="form-group" role="group" aria-label="Scale selection">
        {Array.from({ length: 11 }, (_, k) => (
          <Button
            key={k}
            title={k.toString()}
            type={isTrue(k) ? 'primary' : 'secondary'}
            onClick={() => setFieldValue(group.key, k)}
            style={{
              height: `${k * 10 + 60}px`
            }}
            aria-pressed={isTrue(k)}
          />
        ))}
      </div>
      <div
        className="form-group-limits"
        style={{ borderColor: getStyle('BUTTON_SECONDARY_BORDER', true) }}
      >
        <span>
          <DynamicTypography content={g.options[0].graph_bottom} />
        </span>
        <span>
          <DynamicTypography content={g.options[0].graph_top} />
        </span>
      </div>
    </section>
  );
};
